import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinReturnsTemplateDropdownComponent extends Component {
  @service organisation;
  @service betaToggle;

  confirmedTippy = null;

  get documentBody() {
    return document.body;
  }

  get offset() {
    return [0, 16];
  }

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get dummyTemplates() {
    return [
      'Churn reduction',
      'Increased CLV',
      'Reduced CAC',
      'Time-to-Value Reduction',
      'Improved Conversion Rates',
    ];
  }

  @action
  onClickOutside(instance) {
    instance.hide();
    return;
  }

  @action
  setConfirmedTippy(instance) {
    this.confirmedTippy = instance;
  }
}
